<template>
    <div class="card-challenge-result-item-completed">
        <div class="wr-card-challenge-result-item-completed__users">
            <div class="card-challenge-result-item-completed__user1">
                <div class="wr-card-challenge-result-item-completed__user">
                    <img :src="userImageLink1" class="card-challenge-result-item-completed__user-img">
                    <span class="card-challenge-result-item-completed__username">{{ username1 }}</span>
                    <div
                        class="card-challenge-result-item-completed__user-result"
                        :class="resultClass1">
                        <span class="card-challenge-result-item-completed__user-result-icon"></span>
                        <span class="card-challenge-result-item-completed__user-result-text">{{ userResult1 }}</span>
                    </div>
                </div>
            </div>
            <div class="card-challenge-result-item-completed__user2">
                <div class="wr-card-challenge-result-item-completed__user">
                    <img :src="userImageLink2" class="card-challenge-result-item-completed__user-img">
                    <span class="card-challenge-result-item-completed__username">{{ username2 }}</span>
                    <div
                        class="card-challenge-result-item-completed__user-result"
                        :class="resultClass2">
                        <span class="card-challenge-result-item-completed__user-result-icon"></span>
                        <span class="card-challenge-result-item-completed__user-result-text">{{ userResult2 }}</span>
                    </div>
                </div>
            </div>
            <div class="card-challenge-result-item-completed__separator">
                <span class="card-challenge-result-item-completed__separator-icon"></span>
                <span class="card-challenge-result-item-completed__separator-text">VS</span>
            </div>
        </div>
        <div
            class="card-challenge-result-item-completed__correctness"
            >
            <span
                class="card-challenge-result-item-completed__correctness-user1"
                :class="resultClass1">%{{ resultItem.stats.correctness.user1 }}</span>
            <span class="card-challenge-result-item-completed__correctness-label">DOĞRULUK</span>
            <span
                class="card-challenge-result-item-completed__correctness-user2"
                :class="resultClass2">%{{ resultItem.stats.correctness.user2 }}</span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            resultItem: {
                type: Object,
                default: {
                    id: 9,
                    status: "COMPLETED",
                    user1: {
                        id: 1,
                        username: "temren",
                        status: "DONE-PRACTICE"
                    },
                    user2: {
                        id: 3,
                        username: "kral1790",
                        status: "DONE-PRACTICE"
                    },
                    results: {
                        draw: false,
                        user1: "winner",
                        user2: "loser",
                    },
                    stats: {
                        correctness: {
                            user1: 40,
                            user2: 10
                        },
                        correct: {
                            user1: 15,
                            user2: 12
                        },
                        incorrect: {
                            user1: 3,
                            user2: 7
                        },
                        skipped: {
                            user1: 2,
                            user2: 1
                        }
                    }
                }
            },
        },

        computed: {
            resultClass1(){
                if(this.resultItem.results.draw){
                    return 'card-challenge-result-item-completed--draw';
                }
                else if(this.resultItem.user1.status === 'LEFT-PRACTICE'){
                    return 'card-challenge-result-item-completed--left-practice';
                }
                return `card-challenge-result-item-completed--${this.resultItem.results.user1}`;
            },

            resultClass2(){
                if(this.resultItem.results.draw){
                    return 'card-challenge-result-item-completed--draw';
                }
                else if(this.resultItem.user2.status === 'LEFT-PRACTICE'){
                    return 'card-challenge-result-item-completed--left-practice';
                }
                return `card-challenge-result-item-completed--${this.resultItem.results.user2}`;
            },

            userImageLink1(){
                // return this.$store.state.api.img + this.resultItem.user1.id + '.jpg';
                return this.$store.state.api.getImage + this.resultItem.user1.id;
            },

            userImageLink2(){
                // return this.$store.state.api.img + this.resultItem.user2.id + '.jpg';
                return this.$store.state.api.getImage + this.resultItem.user2.id;
            },

            username1(){
                if(this.$store.state.challengeSession.userType === 1){
                    return 'sen';
                }
                return this.resultItem.user1.username;
            },

            username2(){
                if(this.$store.state.challengeSession.userType === 2){
                    return 'sen';
                }
                return this.resultItem.user2.username;
            },

            userResult1(){
                let curUserType = this.$store.state.challengeSession.userType;
                if(this.resultItem.results.draw){
                    return this.$t('challenge.results.draw');
                }
                else if(this.resultItem.user1.status === 'LEFT-PRACTICE'){
                    return curUserType === 1
                           ? this.$t('challenge.status.left-practice') + 'N'
                           : this.$t('challenge.status.left-practice');;
                }
                else if(this.resultItem.results.user1 === 'winner'){
                    return curUserType === 1
                           ? this.$t('challenge.results.winner') + 'N'
                           : this.$t('challenge.results.winner');
                }
                else if(this.resultItem.results.user1 === 'loser'){
                    return curUserType === 1
                           ? this.$t('challenge.results.loser') + 'N'
                           : this.$t('challenge.results.loser');
                }
            },

            userResult2(){
                let curUserType = this.$store.state.challengeSession.userType;
                if(this.resultItem.results.draw){
                    return this.$t('challenge.results.draw');
                }
                else if(this.resultItem.user2.status === 'LEFT-PRACTICE'){
                    return curUserType === 2
                           ? this.$t('challenge.status.left-practice') + 'N'
                           : this.$t('challenge.status.left-practice');
                }
                else if(this.resultItem.results.user2 === 'winner'){
                    return curUserType === 2
                           ? this.$t('challenge.results.winner') + 'N'
                           : this.$t('challenge.results.winner');
                }
                else if(this.resultItem.results.user2 === 'loser'){
                    return curUserType === 2
                           ? this.$t('challenge.results.loser') + 'N'
                           : this.$t('challenge.results.loser');
                }
            }
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-result-item-completed.css"></style>